export { default } from './LabOrders';
